export default __webpack_public_path__ + "static/media/fullscreen-enter-icon.38373c8a.svg";